'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
function LoginInline(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.init();
}

LoginInline.prototype = $.extend({}, {
    construtor: 'LoginInline',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.off('click', '.login-redirect');
        _this.$container.on('click', '.login-redirect', function loginRedirectClb() {
            services.get('window').redirectTo($(this).attr('href'));

            return false;
        });

        _this.$container.off('click', '.btn-login');
        _this.$container.on('click', '.btn-login', function loginClb() {
            _this.login();

            return false;
        });

        return _this;
    },
    
    login: function login() {
        var _this = this;

        var loginData = {
            step: 2,
            email: _this.$container.find('.input-email').val(),
            password: _this.$container.find('.input-password').val()
        };

        var $wrapper = _this.$container.find('.login-inline');
        blockElement($wrapper);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=login&method=js_login', loginData, function loginClb(res) {
            unBlockElement($wrapper);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$container.find('.login-redirect').click();
                } else {
                    services.get('notifications').viewMsg(services.get('translator').trans('Login'), services.get('translator').trans('LoginFailed'));
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);

        _this.registerCallbacks();

        return _this;
    }
});
